import { render, staticRenderFns } from "./borderTab.vue?vue&type=template&id=b71903b4&scoped=true&"
import script from "./borderTab.vue?vue&type=script&lang=js&"
export * from "./borderTab.vue?vue&type=script&lang=js&"
import style0 from "./borderTab.vue?vue&type=style&index=0&id=b71903b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71903b4",
  null
  
)

export default component.exports